export enum AlertBlockVariant {
  info = 'info',
  success = 'success',
  warning = 'warning',
  danger = 'danger',
  high = 'high',
  low = 'low'
}

export enum AlertBlockSize {
  sm = 'sm',
  md = 'md',
  lg = 'lg'
}

export enum MarginSize {
  sm = 'sm',
  md = 'md',
  lg = 'lg',
  none = 'none'
}

export interface DismissDetails {
  closedByUser: boolean;
}


// MDX constants

export const DEFAULT_LABEL = "Oi, Rodney! Take your leg out of that dog's mouth, will you? Don't be a plonker all your life.";
export const LONG_LABEL = "Oi, Rodney! Take your leg out of that dog's mouth, will you? Don't be a plonker all your life. Mais oui. Gordon Bennett! I might be able to con people into buying my cars, I might be able to convince them that you conceived and gave birth in seven days flat, but how the hell am I going to persuade them my grandad was Louis Armstrong? T'riffic Stone me! ";

